import { render, staticRenderFns } from "./SendNotificationModal.vue?vue&type=template&id=600f72ed"
import script from "./SendNotificationModal.vue?vue&type=script&lang=js"
export * from "./SendNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports